module.exports = __webpack_public_path__ + "static/media/fourofour.f200696a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fourofour.png
// module id = 843
// module chunks = 17